import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer7GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Игрок 2"
        attackSignal="random2_attack"
        healSignal="random2_heal"
        attackDescription="Три предупреждённых луча бьют сверху вниз по душе. Урон 15."
        healDescription="Тонкие лучи случайно бьют по полю. Лечение 5."
    />
);
